import { ErrorMessage } from './ErrorSection.type';
import invalidSearch from '@/assets/invalid-search.svg';
import notFound from '@/assets/not-found.svg';
import generalError from '@/assets/problem-error.svg';

export const defineTitle = (status: number, message: string): string => {
  if (status === 500 || status === 404 || (status === 400 && message === ErrorMessage.SignCantBeSign)) {
    return 'ERROR.500_TITLE';
  } else if (
    (status === 400 && message === ErrorMessage.SignNotActive) ||
    message === ErrorMessage.ReqExpired
  ) {
    return 'ERROR.SIGNATURE_NOT_ACTIVE_TITLE';
  } else if ((status === 400 && message === ErrorMessage.NotFound) || status === 401) {
    return 'ERROR.NOT_FOUND_TITLE';
  }
  return '';
};
export const defineTexts = (status: number, message: string): string => {
  if (status === 500 || status === 404 || (status === 400 && message === ErrorMessage.SignCantBeSign)) {
    const text = 'ERROR.500_SUBTITLE';
    return text;
  } else if (
    (status === 400 && message === ErrorMessage.SignNotActive) ||
    message === ErrorMessage.ReqExpired
  ) {
    const text = 'ERROR.REQUEST_EXPIRED_SUBTITLE';
    return text;
  } else if ((status === 400 && message === ErrorMessage.NotFound) || status === 401) {
    return 'ERROR.NOT_FOUND_SUBTITLE';
  }
  return '';
};

export const setErrorCardImg = (status: number, message: string): string => {
  if (status === 500 || status === 404 || (status === 400 && message === ErrorMessage.SignCantBeSign)) {
    return generalError;
  } else if (
    (status === 400 && message === ErrorMessage.SignNotActive) ||
    message === ErrorMessage.ReqExpired
  ) {
    return invalidSearch;
  } else if ((status === 400 && message === ErrorMessage.NotFound) || status === 401) {
    return notFound;
  }
  return '';
};
